class GetmanLoadMore extends HTMLElement {
  connectedCallback() {
    this.link = this.querySelector('a');
    if (this.link) this.link.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    event.preventDefault();
    const url = this.link.dataset.url;
    if (!url) return;

    this.link.setAttribute('aria-busy', 'true');
    this.link.classList.add('gm-load-more__button--loading');

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('#product-grid .gm-catalog-grid__item');
        const grid = document.getElementById('product-grid');

        newItems.forEach((item) => grid.appendChild(item));

        const newLoadMore = doc.querySelector('getman-load-more');
        this.replaceWith(newLoadMore || document.createTextNode(''));
      })
      .catch((error) => {
        console.error(error);
        this.link.removeAttribute('aria-busy');
        this.link.classList.remove('gm-load-more__button--loading');
      });
  }
}

customElements.define('getman-load-more', GetmanLoadMore);
